module.exports = __webpack_public_path__ + "static/media/warning.4882f925.svg";